<!-- Header -->
<div class="Header">
    <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <div class="container-fluid">
            <!-- Hamburger Menu Button for Mobile -->
            <button class="navbar-toggler d-lg-none hamburger-btn" type="button" (click)="toggleMobileSidebar()" 
                    [attr.aria-expanded]="isMobileSidebarOpen" aria-label="Toggle navigation">
                <i [ngClass]="isMobileSidebarOpen ? 'bi bi-x' : 'bi bi-list'" class="hamburger-icon"></i>
            </button>

            <!-- Search Form with Profile Picture and Notifications for Mobile -->
            <div class="d-flex align-items-center search-and-profile-mobile">
                <div class="search-container">
                    <form class="search-form">
                        <i class="fa fa-search-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
                                    stroke="#767676" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round"></path>
                                <path d="M18.9304 20.6898C19.4604 22.2898 20.6704 22.4498 21.6004 21.0498C22.4504 19.7698 21.8904 18.7198 20.3504 18.7198C19.2104 18.7098 18.5704 19.5998 18.9304 20.6898Z"
                                    stroke="#767676" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round"></path>
                            </svg>
                        </i>
                        <input type="text" class="form-control search-input" placeholder="Search for what you want">
                    </form>
                </div>
                <!-- Notifications for Mobile (visible only on mobile) -->
                <div class="notification-mobile d-lg-none">
                    <app-notification-feed></app-notification-feed>
                </div>
                <!-- Profile Picture for Mobile (visible only on mobile) -->
                <div class="profile-pic-mobile d-lg-none">
                    <div class="profile-pic-container">
                        <div class="profile-pic profile-avatar-svg-header" [routerLink]="[AppConstants.ROUTES.Profile]">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="20" cy="20" r="20" fill="url(#gradientHeader)"/>
                                <circle cx="20" cy="15" r="8" fill="white" opacity="0.9"/>
                                <path d="M11 31C11 27 15 23 20 23C25 23 29 27 29 31" fill="white" opacity="0.9"/>
                                <defs>
                                    <linearGradient id="gradientHeader" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                                        <stop offset="0%" stop-color="#532E60"/>
                                        <stop offset="100%" stop-color="#8e6b8e"/>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <!-- header.component.html -->
            <div class="collapse navbar-collapse" id="navbarScroll">
                <ul class="navbar-nav ms-auto my-2 my-lg-0 navbar-nav-scroll" style="--bs-scroll-height: 100px;">
                    <li class="nav-item d-none d-lg-block" style="margin-right: 10px;">
                        <!-- Notification feed component -->
                        <app-notification-feed></app-notification-feed>
                    </li>
                    <!-- <li class="nav-item messages-icon-container" style="margin-right: 10px;">
                        <a class="nav-link" [routerLink]="[AppConstants.ROUTES.Messages]">
                            <div class="messages-wrapper position-relative">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z" stroke="#767676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M22.0003 12.8598C22.0003 15.1498 20.8203 17.1798 19.0003 18.4598L17.6603 21.4098C17.3503 22.0798 16.4503 22.2098 15.9803 21.6398L14.5003 19.8598C12.0803 19.8598 9.92031 18.7898 8.57031 17.1198L9.50031 15.9998C13.6403 15.9998 17.0003 12.8698 17.0003 8.99982C17.0003 7.94982 16.7503 6.95982 16.3003 6.06982C19.5703 6.81982 22.0003 9.5798 22.0003 12.8598Z" stroke="#767676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7 9H12" stroke="#767676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span class="messages-badge">64</span>
                            </div>
                        </a>
                    </li> -->
                    <!-- <li class="nav-item">
                        <a class="nav-link">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z"
                        stroke="#767676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M22.0003 12.8598C22.0003 15.1498 20.8203 17.1798 19.0003 18.4598L17.6603 21.4098C17.3503 22.0798 16.4503 22.2098 15.9803 21.6398L14.5003 19.8598C12.0803 19.8598 9.92031 18.7898 8.57031 17.1198L9.50031 15.9998C13.6403 15.9998 17.0003 12.8698 17.0003 8.99982C17.0003 7.94982 16.7503 6.95982 16.3003 6.06982C19.5703 6.81982 22.0003 9.5798 22.0003 12.8598Z"
                        stroke="#767676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7 9H12" stroke="#767676" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                        </a>
                    </li> -->
                    <!-- <li class="nav-item">
                        <a class="nav-link">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M19.5 18H18.177C17.8491 18 17.6852 18 17.5582 17.914C17.4312 17.8281 17.3703 17.6758 17.2486 17.3714L16.7514 16.1286C16.6297 15.8242 16.5688 15.6719 16.4418 15.586C16.3148 15.5 16.1509 15.5 15.823 15.5H13.5C13.0286 15.5 12.7929 15.5 12.6464 15.3536C12.5 15.2071 12.5 14.9714 12.5 14.5V10.5M12.5 8V10.5M12.5 10.5H16.3889"
                        stroke="#767676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M12.5 6C11.3954 6 10.5 5.10457 10.5 4C10.5 2.89543 11.3954 2 12.5 2C13.6046 2 14.5 2.89543 14.5 4C14.5 5.10457 13.6046 6 12.5 6Z"
                        stroke="#767676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M9.55796 10C6.68735 10.4794 4.5 12.9645 4.5 15.9582C4.5 19.295 7.21743 22 10.5696 22C12.6003 22 14.3982 21.0072 15.5 19.4826"
                        stroke="#767676" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                        </a>
                    </li> -->
                    <li class="vertical-bar d-none d-lg-block"></li>
                    <li class="nav-item d-none d-lg-block">
                        <div class="profile-card">
                            <div class="profile-pic-container">
                                <div class="profile-pic profile-avatar-svg-header" [routerLink]="[AppConstants.ROUTES.Profile]">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="20" cy="20" r="20" fill="url(#gradientHeaderDesktop)"/>
                                        <circle cx="20" cy="15" r="8" fill="white" opacity="0.9"/>
                                        <path d="M11 31C11 27 15 23 20 23C25 23 29 27 29 31" fill="white" opacity="0.9"/>
                                        <defs>
                                            <linearGradient id="gradientHeaderDesktop" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                                                <stop offset="0%" stop-color="#532E60"/>
                                                <stop offset="100%" stop-color="#8e6b8e"/>
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <div class="profile-name d-flex align-items-center gap-1">
                                    {{this.user?.FullName}}
                                    <span *ngIf="user?.ContactType === 'Primary'" class="contact-type-badge contact-type-primary" title="Primary contact">
                                        <i class="bi bi-star-fill"></i>
                                    </span>
                                    <span *ngIf="user?.ContactType === 'Secondary'" class="contact-type-badge contact-type-secondary" title="Secondary contact">
                                        <i class="bi bi-person-badge"></i>
                                    </span>
                                </div>
                                <div class="profile-role">NTX Manager</div>
                            </div>
                            <div class="dropdown">
                                <button class="btn dropdown-button" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-chevron-down" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                        </svg>
                    </button>
                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="right: 0px !important; left: initial;">
                                    <li><a class="dropdown-item" (click)="logout()" style="cursor: pointer;">Logout</a></li>
                                    <li><a class="dropdown-item" [routerLink]="[AppConstants.ROUTES.Profile]">Profile</a></li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>



        </div>
    </nav>
</div>